export const ADD_ACCESS = 'ADD_ACCESS';
export const ADD_ACCESSES = 'ADD_ACCESSES';
export const REMOVE_ACCESS = 'REMOVE_ACCESS';
export const EDIT_ACCESS = 'EDIT_ACCESS';
export const SET_ACCESSES = 'SET_ACCESSES';
export const RESET_ACCESSES = 'RESET_ACCESSES';

export function addAccess(value) {
  return {
    type: ADD_ACCESS,
    value,
  };
}

export function addAccesses(value) {
  return {
    type: ADD_ACCESSES,
    value,
  };
}

export function removeAccess(accessId) {
  return {
    type: REMOVE_ACCESS,
    accessId,
  };
}

export function editAccess(value) {
  return {
    type: EDIT_ACCESS,
    value,
  };
}

export function setAccesses(value) {
  return {
    type: SET_ACCESSES,
    value,
  };
}

export function resetAccesses() {
  return {
    type: RESET_ACCESSES,
  };
}
